export default {
  type: 'schedule',
  name: 'Scheduled Reports',
  newButton: false,
  search: {
    search: 'allMetricsDashSchedules',
    orderBy: {
      type: 'MetricsDashSchedulesOrderBy',
      default: 'REPORT_NAME_ASC'
    },
    fields: [
      {
        name: 'scheduleName',
        searchable: false,
        order: 'SCHEDULE_NAME'
      },
      {
        name: 'reportName',
        searchable: false,
        order: 'REPORT_NAME'
      },
      [
        {
          name: 'scheduleSunday',
          label: 'Sunday',
          type: 'checkbox',
          width: 1,
          showResults: false
        },
        {
          name: 'scheduleMonday',
          label: 'Monday',
          type: 'checkbox',
          width: 1,
          showResults: false
        },
        {
          name: 'scheduleTuesday',
          label: 'Tuesday',
          type: 'checkbox',
          width: 1,
          showResults: false
        },
        {
          name: 'scheduleWednesday',
          label: 'Wednesday',
          type: 'checkbox',
          width: 1,
          showResults: false
        },
        {
          name: 'scheduleThursday',
          label: 'Thursday',
          type: 'checkbox',
          width: 1,
          showResults: false
        },
        {
          name: 'scheduleFriday',
          label: 'Friday',
          type: 'checkbox',
          width: 1,
          showResults: false
        },
        {
          name: 'scheduleSaturday',
          label: 'Saturday',
          type: 'checkbox',
          width: 1,
          showResults: false
        },
        {
          name: 'scheduleQuarter',
          label: 'Start of Quarter',
          type: 'checkbox',
          showResults: false
        },
        {
          name: 'scheduleDayMonth',
          label: 'Day of Month',
          type: 'select',
          fieldType: 'Int',
          options: [
            { value: null, text: '' },
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28
          ],
          showResults: false
        }
      ],
      [
        {
          name: 'scheduleSave',
          label: 'Saves to My Saved Reports',
          type: 'checkbox',
          width: 4
        },
        {
          name: 'schedulePdf',
          label: 'Emails PDF',
          type: 'checkbox',
          width: 4
        },
        {
          name: 'scheduleExcel',
          label: 'Emails Excel',
          type: 'checkbox',
          width: 4
        }
      ]
    ]
  },
  save: {
    fields: [
      {
        field: 'scheduleId',
        required: true,
        type: 'Int'
      },
      'scheduleName',
      {
        field: 'scheduleSunday',
        type: 'Boolean',
        required: true,
        default: false
      },
      {
        field: 'scheduleMonday',
        type: 'Boolean',
        required: true,
        default: false
      },
      {
        field: 'scheduleTuesday',
        type: 'Boolean',
        required: true,
        default: false
      },
      {
        field: 'scheduleWednesday',
        type: 'Boolean',
        required: true,
        default: false
      },
      {
        field: 'scheduleThursday',
        type: 'Boolean',
        required: true,
        default: false
      },
      {
        field: 'scheduleFriday',
        type: 'Boolean',
        required: true,
        default: false
      },
      {
        field: 'scheduleSaturday',
        type: 'Boolean',
        required: true,
        default: false
      },
      {
        field: 'scheduleQuarter',
        type: 'Boolean',
        required: true,
        default: false
      },
      {
        field: 'scheduleDayMonth',
        type: 'Int'
      },
      {
        field: 'reportName',
        required: true
      },
      {
        field: 'scheduleFilter',
        type: 'JSON'
      },
      'scheduleChartType',
      {
        field: 'scheduleRelativeDates',
        type: 'Boolean',
        required: true,
        default: true
      },
      {
        field: 'scheduleSave',
        type: 'Boolean',
        required: true,
        default: false
      },
      {
        field: 'schedulePdf',
        type: 'Boolean',
        required: true,
        default: false
      },
      {
        field: 'scheduleExcel',
        type: 'Boolean',
        required: true,
        default: false
      }
    ],
    key: ['scheduleId'],
    input: 'metricsDashSchedule',
    create: 'createMetricsDashSchedule',
    delete: 'deleteMetricsDashSchedule',
    update: 'updateMetricsDashSchedule'
  },
  load: {
    nodeId: 'metricsDashSchedule',
    key: 'metricsDashScheduleByScheduleId'
  },
  form: {
    print: false,
    schema: [
      {
        name: 'reportName',
        readonly: true
      },
      {
        type: 'message',
        message:
          'Note: you cannot change the report parameters from this screen.  To do that, please delete this schedule and re-run the report with the appropriate parameters then re-schedule it.',
        hideIf: {
          field: 'scheduleId',
          value: null
        }
      },
      {
        name: 'scheduleFilter',
        type: 'hidden'
      },
      {
        name: 'scheduleChartType',
        type: 'hidden'
      },
      {
        name: 'scheduleName'
      },
      [
        {
          name: 'scheduleRunDefaults',
          label: 'Run With Default Parameters',
          type: 'checkbox',
          default: true,
          width: 4
        },
        {
          name: 'scheduleRelativeDates',
          label: 'Use Relative Dates When Running',
          help: 'If unchecked then exact dates will be used',
          type: 'checkbox',
          default: true,
          width: 4,
          showIf: {
            field: 'scheduleRunDefaults',
            value: false
          }
        }
      ],
      {
        type: 'message',
        message:
          'To run this weekly: select the day(s) of the week you would like to run the report.  To run this quarterly: select Start of Quarter for the first day of each fiscal quarter or you can enter a day of month along with the Start of Quarter to run it on that day for the months of January, April, July, and October.  To run the report monthly: enter the day of the month you would like to run the report.'
      },
      [
        {
          name: 'scheduleSunday',
          label: 'Sunday',
          type: 'checkbox',
          width: 1
        },
        {
          name: 'scheduleMonday',
          label: 'Monday',
          type: 'checkbox',
          width: 1
        },
        {
          name: 'scheduleTuesday',
          label: 'Tuesday',
          type: 'checkbox',
          width: 1
        },
        {
          name: 'scheduleWednesday',
          label: 'Wednesday',
          type: 'checkbox',
          width: 1
        },
        {
          name: 'scheduleThursday',
          label: 'Thursday',
          type: 'checkbox',
          width: 1
        },
        {
          name: 'scheduleFriday',
          label: 'Friday',
          type: 'checkbox',
          width: 1
        },
        {
          name: 'scheduleSaturday',
          label: 'Saturday',
          type: 'checkbox',
          width: 1
        },
        {
          name: 'scheduleQuarter',
          label: 'Start of Quarter',
          type: 'checkbox'
        },
        {
          name: 'scheduleDayMonth',
          label: 'Day of Month',
          type: 'select',
          options: [
            { value: null, text: '' },
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28
          ]
        }
      ],
      {
        type: 'message',
        message: 'Select what you would like to do with the report'
      },
      [
        {
          name: 'scheduleSave',
          label: 'Save to My Saved Reports',
          type: 'checkbox',
          width: 4
        },
        {
          name: 'schedulePdf',
          label: 'Email PDF',
          type: 'checkbox',
          width: 4
        },
        {
          name: 'scheduleExcel',
          label: 'Email Excel',
          type: 'checkbox',
          width: 4
        }
      ]
    ]
  }
}
